import { sidebarPanelOverlayLockAtom } from '@/atoms/sidebarPanelAtoms';
import { IS_SIDEBAR_PANEL_ENABLED } from '@/components/constants/flags';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * Increments the sidebar panel overlay lock while `isOpen` is true,
 * preventing the panel from hiding or switching content while a
 * portal-based overlay (popover, combobox, hover card) is visible.
 *
 * Decrements on close or unmount. `Math.max(0, …)` guards against
 * negative drift if cleanup fires more than once.
 */
export function useSidebarPanelOverlayLock(isOpen: boolean) {
  const isSidebarPanelEnabled = IS_SIDEBAR_PANEL_ENABLED();
  const setSidebarOverlayLock = useSetAtom(sidebarPanelOverlayLockAtom);

  useEffect(() => {
    if (!isSidebarPanelEnabled || !isOpen) return;

    setSidebarOverlayLock((c) => c + 1);
    return () => {
      setSidebarOverlayLock((c) => Math.max(0, c - 1));
    };
  }, [isOpen, isSidebarPanelEnabled, setSidebarOverlayLock]);
}
